import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

import ASTINavBar from '../navbar/ASTINavbar';
import ASTIHeader from '../labels/ASTIHeader';
import ASTIDashboardBody from './ASTIDashboardBody';
import ASTINavBarMobile from '../navbar/ASTINavbarMobile';
import PelmeshkaLogo from '../../assets/images/pelmeshkalogo.png';
import { BANKS_STORAGE_KEY } from '../../constants/banks';

export default function ASTIDashboard() {
  const [section, setSection] = useState('default');
  const [enabledBanks, setEnabledBanks] = useState(() => {
    try {
      const stored = localStorage.getItem(BANKS_STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(BANKS_STORAGE_KEY, JSON.stringify(enabledBanks));
  }, [enabledBanks]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      position="relative"
    >
      <Box
        display="flex"
        flexDirection={{ xs: 'row', sm: 'column' }}
        justifyContent="center"
        alignItems="center"
        py={4}
        width="100%"
        position="fixed"
        top={0}
        sx={{
          backgroundColor: '#FFFFFF',
          borderBottom: '1px solid #D4B896',
          zIndex: 1200,
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
        }}
      >
        {/* Mobile navbar */}
        <ASTINavBarMobile section={section} setSection={setSection} enabledBanks={enabledBanks} />

        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          <img src={PelmeshkaLogo} alt="pelmeshka_logo" width="5%" />
          <ASTIHeader text="Pelmeshka" />
        </Box>

        {/* Desktop navbar */}
        <ASTINavBar section={section} setSection={setSection} enabledBanks={enabledBanks} />
      </Box>
      <Box
        pt={{ xs: 20, sm: 37.5 }} // Highlight: Extra top padding for smaller screens
        pb={2}
      >
        <ASTIDashboardBody section={section} enabledBanks={enabledBanks} setEnabledBanks={setEnabledBanks} />
      </Box>
    </Box>
  );
}
